import react from 'react'
import { BrowserRouter, Routes, Route, Navigation, Navigate } from 'react-router-dom'

import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import DashboardDetails from './pages/DashboardDetails'
import NotFound from './pages/NotFound'
import Unauthorized from './pages/Unauthorized'
import Users from './pages/Users'
import AddUser from './pages/AddUser'
import Account from './pages/Account'
import Devices from './pages/Devices'
import Help from './pages/Help'

import ProtectedRoute from './routes/ProtectedRoute'
import AdminRoute from './routes/AdminRoute'

function App() {

  return (
    <BrowserRouter>
      <Routes>
        <Route 
          path="/"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route 
          path="/details"
          element={
            <ProtectedRoute>
              <DashboardDetails />
            </ProtectedRoute>
          }
        />
        <Route 
          path="/users"
          element={
            <ProtectedRoute>
              <AdminRoute>
                <Users />
              </AdminRoute>
            </ProtectedRoute>
          }
        />
        <Route 
          path="/users/add"
          element={
            <ProtectedRoute>
              <AdminRoute>
                <AddUser />
              </AdminRoute>
            </ProtectedRoute>
          }
        />
        <Route 
          path="/devices"
          element={
            <ProtectedRoute>
              <AdminRoute>
                <Devices />
              </AdminRoute>
            </ProtectedRoute>
          }
        />
        <Route 
          path="/account"
          element={
            <ProtectedRoute>
              <AdminRoute>
                <Account />
              </AdminRoute>
            </ProtectedRoute>
          }
        />
        <Route 
          path="/help"
          element={
            <ProtectedRoute>
              <Help />
            </ProtectedRoute>
          }
        />
        <Route path='/login' element={<Login />}/>
        <Route path='/unauthorized' element={<Unauthorized />}/>
        <Route path='*' element={<NotFound />}/>
      </Routes>
    </BrowserRouter>
  )
}

export default App